import {createAnatomy} from '@zag-js/anatomy';

export const paginationAnatomy = createAnatomy(`pagination`).parts(
  `root`,
  `list`,
  `trigger`,
  `ellipsis`,
  `counter`,
  `item`,
  `group`,
);

export const parts = paginationAnatomy.build();

export type Part = keyof typeof parts;
